export const commentTextDataSet = { cy: 'comment-text' };
export const deleteCommentDataSet = { cy: 'delete-comment-button' };
